import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, object=auth

  // Runs once on mount. Auth state lives in an httpOnly cookie, so we simply ask the
  // server who we are; a 401 means "not logged in".
  useEffect(() => {
    let active = true;
    api
      .get("/auth/me")
      .then((res) => active && setUser(res.data))
      .catch((err) => {
        if (err?.response?.status !== 401) {
          console.error("Auth check failed:", err?.message || err);
        }
        if (active) setUser(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed:", err?.message || err);
    }
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
